const API_LANGUAGE_KEY = 'app_language';

export function normalizeAPILanguage(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return 'en';
  const normalized = trimmed.replaceAll('-', '_');
  const parts = normalized.split('_');
  const base = parts[0].toLowerCase();
  if (base === 'en') return 'en';
  if (base === 'zh') {
    if (parts.length === 1 || String(parts[1]).toUpperCase() === 'CN') return 'zh_CN';
    return 'en';
  }
  if (parts.length === 1 && /^[a-z]{2}$/.test(base)) return base;
  if (parts.length === 2 && /^[a-z]{2}$/.test(base) && /^[a-z]{2}$/i.test(parts[1])) {
    return `${base}_${parts[1].toUpperCase()}`;
  }
  return 'en';
}

export function getAPILanguage() {
  if (typeof localStorage === 'undefined') return 'en';
  return normalizeAPILanguage(localStorage.getItem(API_LANGUAGE_KEY));
}

export function withLanguage(config = {}, language = getAPILanguage()) {
  return {
    ...config,
    params: {
      ...(config.params || {}),
      lang: normalizeAPILanguage(language),
    },
  };
}

export function responseEnvelope(response) {
  const envelope = response?.data;
  if (!envelope || typeof envelope !== 'object' || typeof envelope.code !== 'number' || !Object.prototype.hasOwnProperty.call(envelope, 'data')) return null;
  return envelope;
}

export function responseData(response) {
  const envelope = responseEnvelope(response);
  return envelope?.code === 0 ? envelope.data : response?.data;
}

export function apiErrorCode(error) {
  const code = error?.response?.data?.code;
  return typeof code === 'number' ? code : null;
}

export function apiErrorDetail(error, fallback) {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' && detail.trim() ? detail : fallback;
}
